const fb = require("../firebase.js");

export default {
  namespaced: true,
  state: {
    user: {},
    userPending: false,
    userError: null,
  },
  mutations: {
    setUser (state, value) {
      state.user = value
    },
    setUserPending (state, value) {
      state.userPending = value
    },
    setUserError (state, value) {
      state.userError = value
    },
  },
  actions: {
    async createUser ({ dispatch }, user) {
      fb.db
        .collection("users")
        .doc(user.uid)
        .set({
          createdAt: fb.firebase.firestore.Timestamp.now(),
        })
        .then(()=> {
          dispatch("self/getSelf", null, { root: true })
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getUser ({ commit }, userId) {
      if(!fb.firebase.auth().currentUser) return
      if(userId === fb.firebase.auth().currentUser.uid) {
        commit('setUser', {})
        return
      }
      commit('setUser', { id: "wait"})
      commit('setUserPending', true)
      fb.db.collection("users").doc(userId).get().then((doc) => {
        if (doc.exists) {
          commit('setUser', { id: doc.id, ...doc.data() })
          commit('setUserPending', false)
        } else {
          commit('setUserPending', false)
          return console.log("No such document!");
        }
      }).catch((error) => {
        commit('setUserError', error)
        commit('setUserPending', false)
      });
    },
  }
}
  